import { useContext } from "react";
import USQSContext from "../contexts/USQSProvider";

const useUSQS = () => {
  return useContext(USQSContext);
};

export default useUSQS;
